import { mapState } from 'vuex';
import styled from 'vue-styled-components';
import { fontSize } from 'styled-system';
import { Section, Center, Row, Col } from '@styled/global';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n   cursor: pointer;\n   list-style-type: none;\n   text-align: left;\n   flex-direction: column;\n   display: flex;\n   flex-direction: column;\n   margin: 4px 0;\n\n   & a {\n      color: ", ";\n   }\n\n   & a:hover: {\n      text-decoration: underline;\n   }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   vertical-align: middle;\n   text-align: center;\n   text-decoration: none;\n   appearance: none;\n   display: flex;\n   flex-direction: column;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   overflow: hidden;\n   overflow-wrap: break-word;\n   text-align: justify;\n   width: 100%;\n   padding-left: 20px;\n   padding-right: 20px;\n   line-height: 20px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   transform: rotate(180deg);\n   transition-duration: 0.3s;\n   width: 12px;\n\n   &.rotate {\n      transform: rotate(0deg);\n   }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   position: absolute;\n   width: 12px;\n   top: -1px;\n   left: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   margin: 10px 0;\n   height: 28px;\n   line-height: 24px;\n   position: relative;\n   color: red;\n   cursor: pointer;\n   padding-left: 18px;\n   text-align: left;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Collapsible = styled("div", {})(_templateObject());
var TitleBar = styled("div", {
  fontSize: {
    default: function _default() {
      return [1, 1, 2, 2];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject2(), fontSize);
var Arrow = styled("div", {})(_templateObject3());
var SVG = styled("svg", {})(_templateObject4()); // transition: 0.5s ease-out;

var Body = styled("div", {})(_templateObject5());
var NavBar = styled("ul", {})(_templateObject6());
var NavItem = styled("li", {})(_templateObject7(), function (props) {
  return props.theme.primaryColor;
}); // export const Body = styled("div", {})`
//    overflow: hidden;
//    transition: 0.5s ease-out;
//    overflow-wrap: break-word;
//    text-align: justify;
//    width: 100%;
//    padding-left: 20px;
//    padding-right: 20px;
//    line-height: 20px;
// `;

var script = {
  props: {
    copy: {
      required: false,
      type: Object
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  computed: _extends({}, mapState("viewport", ["breakpoint"])),
  methods: {
    renderLinks: function renderLinks(h) {
      return this.copy.links.map(function (item) {
        return h(NavItem, [h("RouterLink", {
          "attrs": {
            "to": item.url,
            "id": item.id
          }
        }, [item.label])]);
      });
    },
    toggle: function toggle() {
      this.show = !this.show;
    },
    beforeEnter: function beforeEnter(el) {
      // console.log("beforeEnter", el.scrollHeight);
      el.style.height = "0";
    },
    afterEnter: function afterEnter(el) {
      console.log("AFTER ENTRE");
    },
    done: function done(el) {
      console.log("DONE~~~~");
    },
    enter: function enter(el, done) {
      console.log("enter", el.scrollHeight); // Add an event listener to wait for the animation to complete before remove the explicite height style

      var handleAnimationDone = function handleAnimationDone() {
        console.log("Transition ended");
        el.style.height = null;
        el.style.transition = null;
        el.removeEventListener("transitionend", handleAnimationDone);
      };

      el.addEventListener("transitionend", handleAnimationDone); // Delay until the child has a chance to load so detertime the proper height to set

      setTimeout(function () {
        // if (this.isMobile()) {
        el.style.transition = "0.5s ease-out"; // }

        el.style.height = el.scrollHeight + "px";
      }, 200);
    },
    beforeLeave: function beforeLeave(el) {
      console.log("beforeLeave", el.scrollHeight); // if (this.isMobile()) {

      el.style.transition = "0.5s ease-out"; // }

      el.style.height = el.scrollHeight + "px"; // Add an event listener to wait for the animation to complete before remove the explicite height style

      var handleAnimationDone = function handleAnimationDone() {
        console.log("Transition ended");
        el.style.transition = null;
        el.removeEventListener("transitionend", handleAnimationDone);
      };

      el.addEventListener("transitionend", handleAnimationDone); // Wait for the element to register the height change before setting back to zero

      setTimeout(function () {
        el.style.height = "0px";
      }, 100);
    },
    afterLeave: function afterLeave(el) {
      console.log("afterLeave", el.scrollHeight);
    },
    leave: function leave(el, done) {
      // el.style.height = "0";
      console.log("leave", el.scrollHeight); // done();
    },
    arrowClass: function arrowClass() {
      return this.show ? "rotate" : null;
    },
    isMobile: function isMobile() {
      return this.breakpoint === "xs" || this.breakpoint === "sm";
    }
  },
  render: function render(context) {
    var h = arguments[0];
    var body = null;
    var isMobile = this.isMobile();

    if (!isMobile || this.show) {
      var links = this.renderLinks(context);
      body = h(Body, [h(NavBar, [links])]);
    }

    return h(Collapsible, [h(TitleBar, {
      "on": {
        "click": this.toggle
      }
    }, [h("div", {
      "domProps": {
        "innerHTML": this.copy.label
      }
    }), h(Arrow, [isMobile && h(SVG, {
      "class": this.arrowClass(),
      "attrs": {
        "viewBox": "0 0 1024 574",
        "aria-labelledby": "grsi-ant-up-title",
        "id": "si-ant-up"
      }
    }, [h("title", {
      "attrs": {
        "id": "grsi-ant-up-title"
      }
    }, ["icon up"]), h("path", {
      "attrs": {
        "d": "M1015 564q-10 10-23 10t-23-10L512 82 55 564q-10 10-23 10T9 564q-9-10-9-24t9-24L489 10q10-10 23-10t23 10l480 506q9 10 9 24t-9 24z"
      }
    })])])]), h("Transition", {
      "on": {
        "beforeEnter": this.beforeEnter,
        "enter": this.enter,
        "beforeLeave": this.beforeLeave,
        "leave": this.leave
      }
    }, [body])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

// Application imports
var script$1 = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  components: {
    Collapsible: __vue_component__
  },
  render: function render() {
    var h = arguments[0];

    var renderColumns = function renderColumns(columns) {
      return columns.map(function (column, columnIndex) {
        return h(Col, {
          "attrs": {
            "alignItems": "flex-start",
            "flexDirection": "row",
            "width": [12, 12, 6, 3]
          }
        }, [h(__vue_component__, {
          "attrs": {
            "copy": column
          }
        })]);
      });
    };

    return h(Section, {
      "style": {
        borderBottom: "2px solid #fff"
      }
    }, [h(Center, [h(Row, {
      "attrs": {
        "margin": "0 -2px"
      }
    }, [renderColumns(this.copy.columns)])])]);
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = normalizeComponent(
    {},
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__$1;
